
const DEFAULT_EXP = 1000 * 60 * 30; // 30 minutes
const EXP_CACHE_KEY = '_E';
const MAX_ITEM_COUNT = 150; // not enforced

let memoryCache = {};
let itemCount = 0;
let hasInit = false;

function getCache(key) {
    if (!hasInit) init();
    let exp = localStorage.getItem([EXP_CACHE_KEY, key]);
    if (exp && exp > Date.now()) return JSON.parse(localStorage.getItem(key));
}

function setCache(key, value, exp, flush=false) {
    if (!hasInit) init();
    exp = Date.now() + ((!exp) ? DEFAULT_EXP : exp);
    // actual caching
    localStorage.setItem(key, JSON.stringify(value));
    localStorage.setItem([EXP_CACHE_KEY, key], exp);
    itemCount  += 1;
    return value;
}

function getActiveCache(key) {
    if (memoryCache[key]) return memoryCache[key];
    let value = getCache(key);
    if (value) {
        let temp = {};
        temp[key] = value;
        Object.assign(memoryCache, temp);
        return value;
    }
}

function setActiveCache(key, value) {
    let temp = {};
    temp[key] = value;
    Object.assign(memoryCache, temp);
    setCache(key, value, 1000 * 60 * 60 * 24 * 31, true); // cache to last 31 days
    return value;
}

function init() {
    _clearExpiredItems();
    hasInit = true;
    // TODO: schedule _clearExpiredItems to be called every XX minutes
}

function _clearExpiredItems() {
    let date = Date.now();
    Object.keys(localStorage).forEach((key) => {
        if (!key.startsWith(EXP_CACHE_KEY)) {
            let exp = localStorage.getItem([EXP_CACHE_KEY, key]);
            if (!exp) return;
            exp = parseInt(exp);
            if (exp < date) {
                localStorage.removeItem(key);
                localStorage.removeItem([EXP_CACHE_KEY, key]);
                itemCount -= 1;
            }
        }
    });
}

function clear(expiredOnly=false) {
    if (!expiredOnly) {
        localStorage.clear();
        memoryCache = {};
        itemCount = 0;
        init();
    } else _clearExpiredItems();
}

export { getCache, setCache, setActiveCache, getActiveCache, clear };


// WEBPACK FOOTER //
// ./src/common/cache.js